import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { usePincode } from "../../context/PincodeContext";
import "./PincodeModal.css";

// Standalone landing pages that must not be gated by a delivery pincode.
// These are reached by QR from print/packaging by walk-up visitors who are not
// shopping yet — asking for a pincode first is a dead end for the campaign.
const PINCODE_EXEMPT_PATHS = ["/review-reward", "/feedback"];

export default function PincodeModal() {
  const { pincode, setPincode, isModalOpen, closeModal } = usePincode();
  const { pathname } = useLocation();
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  const exempt = PINCODE_EXEMPT_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );

  if (exempt || !isModalOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(value)) {
      setError("Please enter a valid 6-digit pincode");
      return;
    }
    setPincode(value);
    setValue("");
    setError("");
  };

  return (
    <div className="pincode-modal-overlay">
      <div className="pincode-modal">
        <h3>Enter your delivery pincode</h3>
        <p>We'll show you accurate pricing based on your location.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            placeholder="e.g. 110075"
            value={value}
            onChange={(e) => { setValue(e.target.value.replace(/\D/g, "")); setError(""); }}
            autoFocus
          />
          {error && <span className="pincode-modal-error">{error}</span>}
          <button type="submit">Continue</button>
        </form>
        {pincode && (
          <button className="pincode-modal-close" onClick={closeModal} aria-label="Close">×</button>
        )}
      </div>
    </div>
  );
}
